<template>
    <form class="mb-3">
        <div class="row">
            <div class="form-group col-md-2">
                <multiselect
                        v-model="form.month"
                        :options="months"
                        track-by="month"
                        placeholder="Месяц"
                        label="month_title"
                        selectLabel=""
                        :multiple="false"
                        selectedLabel="Выбрано"
                        deselectLabel=""
                        :searchable="false"
                        @select="selectMonth"

                        :allow-empty="false"

                ></multiselect>
            </div>
            <div class="form-group col-md-2">
                <multiselect
                        v-model="form.year"
                        :options="years"
                        placeholder="Год"
                        selectLabel=""
                        :multiple="false"
                        selectedLabel="Выбрано"
                        @input="onChangeYear"
                        :searchable="false"
                        @select="selectYear"
                        :allow-empty="false"
                        deselectLabel=""
                ></multiselect>
            </div>
        </div>
    </form>
</template>
<script>
    import Multiselect from 'vue-multiselect';
    export default {
        components:{
            Multiselect,
        },
        props:[
            'building_id'
        ],
        methods: {
          onChangeYear(year) {

          },
            clearFilter() {
                this.form.month = null;
                this.form.year = null;
                this.$emit('clearFilter')
                this.filtered = false;
            },
          async selectYear(year) {
            let month = await this.getMonths(year);
            console.log(month.month);
              this.$emit('filterSubmit',  {
                month:  month.month,
                year:year,
              });
            this.filtered = true;



            },
            selectMonth(month) {
                console.log(month);
                let data = {
                    month:  month.month,
                    year:this.form.year,
                };
                this.filtered = true;
                this.$emit('filterSubmit', data);
            },
            filterSubmit() {

                let data = {
                    month:  this.form.month.month,
                    year:this.form.year,
                };
                this.filtered = true;
                this.$emit('filterSubmit', data);
            },


           async getMonths(year) {

                 await axios.get('/api/building/'+ this.building_id +'/reports/months-list', {params: {year:year}})
                     .then((response) => {
                         this.months = response.data.list;
                         this.form.month = response.data.last_month;
                     })
                return this.form.month;
            },
            getYears() {
                axios.get('/api/building/'+ this.building_id +'/reports/years-list')
                    .then((response) => {
                        this.years = response.data.list;
                        this.form.year = response.data.last_year;
                        this.getMonths(this.form.year)
                    })

            },
        },
        data() {
            return {
                filtered:false,
                form: {
                    month:null,
                    year:null,
                },
                years:[],
                months:[],
            }
        },

        mounted() {
            this.getYears();

        }
    }
</script>